import { render, staticRenderFns } from "./JsonBrowser.vue?vue&type=template&id=129bf0d8&"
import script from "./JsonBrowser.vue?vue&type=script&lang=js&"
export * from "./JsonBrowser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports